import React, { useState } from 'react'
import { Typewriter } from 'react-simple-typewriter'
import img from '../../../assets/brand/Profile.png'
import { FaFacebookF, FaGithub, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa'
import { AiOutlineDownload } from 'react-icons/ai'

const socialLinks = [
  {
    href: 'https://github.com/shipatulhasan',
    icon: FaGithub,
    color: '#e2e8f0',
    bg: 'rgba(226,232,240,0.08)',
    glow: '0 0 12px rgba(226,232,240,0.2)',
    hoverGlow: '0 0 20px rgba(226,232,240,0.45)',
    label: 'GitHub',
  },
  {
    href: 'https://www.facebook.com/profile.php?id=100082017364458',
    icon: FaFacebookF,
    color: '#4f8ef7',
    bg: 'rgba(79,142,247,0.08)',
    glow: '0 0 12px rgba(79,142,247,0.2)',
    hoverGlow: '0 0 20px rgba(79,142,247,0.5)',
    label: 'Facebook',
  },
  {
    href: 'https://wa.me/8801819051432',
    icon: FaWhatsapp,
    color: '#25D366',
    bg: 'rgba(37,211,102,0.08)',
    glow: '0 0 12px rgba(37,211,102,0.2)',
    hoverGlow: '0 0 20px rgba(37,211,102,0.5)',
    label: 'WhatsApp',
  },
  {
    href: 'https://www.linkedin.com/in/md-shipatul-hasan-shakib/',
    icon: FaLinkedinIn,
    color: '#4f9ef7',
    bg: 'rgba(79,158,247,0.08)',
    glow: '0 0 12px rgba(79,158,247,0.2)',
    hoverGlow: '0 0 20px rgba(79,158,247,0.5)',
    label: 'LinkedIn',
  },
]

const SocialIcon = ({ href, icon: Icon, color, bg, glow, hoverGlow, label }) => {
  const [hovered, setHovered] = useState(false)
  return (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      aria-label={label}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '38px',
        height: '38px',
        borderRadius: '10px',
        background: hovered ? bg : 'rgba(255,255,255,0.03)',
        border: `1px solid ${color}${hovered ? '55' : '22'}`,
        boxShadow: hovered ? hoverGlow : glow,
        transform: hovered ? 'scale(1.18) translateY(-4px)' : 'scale(1)',
        transition: 'all 0.25s cubic-bezier(0.34,1.56,0.64,1)',
        textDecoration: 'none',
      }}
    >
      <Icon style={{
        color: hovered ? color : `${color}88`,
        fontSize: '15px',
        filter: hovered ? `drop-shadow(0 0 6px ${color})` : 'none',
        transition: 'all 0.22s ease',
      }} />
    </a>
  )
}

const ResumeButton = () => {
  const [hovered, setHovered] = useState(false)
  return (
    <a
      href='https://drive.google.com/file/d/1_gDTiZTfp9m3BHUT5zqWyJy3Sqq_2jzH/view?usp=share_link'
      target='_blank'
      rel='noopener noreferrer'
      download=''
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 26px',
        borderRadius: '10px',
        border: `1px solid rgba(250,204,21,${hovered ? '0.65' : '0.28'})`,
        background: hovered
          ? 'linear-gradient(135deg, rgba(250,204,21,0.16), rgba(250,204,21,0.05))'
          : 'linear-gradient(135deg, rgba(250,204,21,0.07), rgba(250,204,21,0.02))',
        color: hovered ? '#facc15' : 'rgba(250,204,21,0.55)',
        fontWeight: 700,
        fontSize: '11px',
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        textDecoration: 'none',
        boxShadow: hovered
          ? '0 0 28px rgba(250,204,21,0.28), inset 0 1px 0 rgba(250,204,21,0.15)'
          : '0 0 12px rgba(250,204,21,0.08), inset 0 1px 0 rgba(250,204,21,0.06)',
        transform: hovered ? 'scale(1.05) translateY(-2px)' : 'scale(1)',
        transition: 'all 0.28s cubic-bezier(0.34,1.56,0.64,1)',
      }}
    >
      <AiOutlineDownload style={{
        fontSize: '16px',
        filter: `drop-shadow(0 0 ${hovered ? '6px' : '3px'} rgba(250,204,21,0.6))`,
        transform: hovered ? 'translateY(2px)' : 'translateY(0)',
        transition: 'all 0.25s ease',
      }} />
      Download Resume
    </a>
  )
}

const Divider = () => (
  <div style={{
    height: '1px',
    margin: '14px 20px',
    background: 'linear-gradient(90deg, transparent, rgba(250,204,21,0.18), transparent)',
    boxShadow: '0 0 6px rgba(250,204,21,0.08)',
  }} />
)

const Sidebar = () => {
  const [loaded, setLoaded] = useState(false)

  return (
    <div style={{ position: 'relative' }}>
      {/* profile image */}
      <div style={{ width: '72%', margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 2 }}>
        <div style={{
          borderRadius: '14px',
          padding: '3px',
          background: loaded
            ? 'linear-gradient(135deg, rgba(250,204,21,0.6), rgba(99,102,241,0.35), rgba(250,204,21,0.6))'
            : 'rgba(255,255,255,0.05)',
          boxShadow: loaded
            ? '0 0 32px rgba(250,204,21,0.22), 0 0 60px rgba(99,102,241,0.1)'
            : 'none',
          transition: 'all 0.7s ease',
        }}>
          <img
            style={{
              borderRadius: '12px',
              objectFit: 'cover',
              display: 'block',
              width: '100%',
              filter: !loaded ? 'blur(4px) brightness(0.5)' : 'none',
              transition: 'filter 0.7s ease',
            }}
            src={img}
            alt='Shakib'
            onLoad={() => setLoaded(true)}
          />
        </div>
      </div>

      {/* glass card */}
      <div style={{
        marginTop: '-120px',
        paddingTop: '136px',
        paddingBottom: '28px',
        borderRadius: '16px',
        background: 'rgba(8,8,14,0.82)',
        backdropFilter: 'blur(28px)',
        WebkitBackdropFilter: 'blur(28px)',
        border: '1px solid rgba(250,204,21,0.12)',
        boxShadow: '0 8px 40px rgba(0,0,0,0.6), inset 0 1px 0 rgba(250,204,21,0.08), 0 0 60px rgba(250,204,21,0.04)',
      }}>

        {/* name — gold + glow */}
        <h2 style={{
          color: '#facc15',
          fontWeight: 800,
          textAlign: 'center',
          fontSize: '1.05rem',
          letterSpacing: '-0.01em',
          marginBottom: '6px',
          padding: '0 16px',
          textShadow: '0 0 20px rgba(250,204,21,0.5), 0 0 40px rgba(250,204,21,0.2)',
        }}>
          Md. Shipatul Hasan Shakib
        </h2>

        {/* designation — highlighted badge style */}
        <div style={{ display: 'flex', justifyContent: 'center', padding: '0 16px 4px' }}>
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '4px 12px',
            borderRadius: '20px',
            background: 'rgba(250,204,21,0.07)',
            border: '1px solid rgba(250,204,21,0.18)',
            fontSize: '12px',
            color: 'rgba(250,204,21,0.75)',
            fontWeight: 600,
            letterSpacing: '0.04em',
            boxShadow: '0 0 12px rgba(250,204,21,0.08)',
          }}>
            <span style={{
              width: '6px', height: '6px', borderRadius: '50%',
              background: '#facc15',
              boxShadow: '0 0 6px rgba(250,204,21,0.8)',
              animation: 'pulse-dot 2.5s ease-in-out infinite',
              flexShrink: 0,
            }} />
            <Typewriter
              words={['Full Stack Developer', 'PERN Stack Developer']}
              loop={false}
              cursor
              cursorStyle='|'
              typeSpeed={65}
              deleteSpeed={30}
              delaySpeed={1200}
            />
          </span>
        </div>

        <Divider />

        {/* social icons — always slightly glowing */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', padding: '6px 0' }}>
          {socialLinks.map((s) => <SocialIcon key={s.label} {...s} />)}
        </div>

        <Divider />

        <div style={{ textAlign: 'center', paddingTop: '8px' }}>
          <ResumeButton />
        </div>
      </div>
    </div>
  )
}

export default Sidebar
